export default "__VITE_ASSET__BA2RK4se__ 1200w";